module.exports = __webpack_public_path__ + "img/andry--pressed.00b1cb5c.svg";